import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';


@Injectable({
  providedIn: 'root'
})

export class DealService {

    baseUrl: string;
    constructor(private http: HttpClient) {
    }
    public getPendingDeals(): Observable<any> {
    this.baseUrl = environment.apiBase.concat("Deal/GetPendingDealsForCurrentUser");
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetPendingDealsForCurrentUser', [])));
    }

    public AcceptDeal(deal: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/AcceptDeal");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, deal, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public PostDealData(deal: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/PostDealData");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, deal, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public DeleteDeal(dealId: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/DeleteDeal?dealId=" + dealId);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public GetDealById(Id, BrokerInfo): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/GetDealById?Id=" + Id + "&&BrokerInfo=" + BrokerInfo);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetDealById', [])));
    }

    public GetDealNotesByDealId(dealId): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/GetDealNotesByDealId?dealId=" + dealId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetDealNotesByDealId', [])));
    }

    public GetDealAdditionalComunnicationUsersByDealId(dealId): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/GetDealAdditionalComunnicationUsersByDealId?dealId=" + dealId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetDealAdditionalComunnicationUsersByDealId', [])));
    }

    public AddDealNote(dealId: any,note: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/AddDealNote?dealId=" + dealId + "&&note=" + note);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public DeleteDealNote(dealnoteId: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/DeleteDealNote?dealnoteId=" + dealnoteId);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public UpdateDealNote(note: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/UpdateDealNote");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');

        return this.http.post(this.baseUrl, note, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public AddDealAdditionalCommunicationUser(dealId: any, userId: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/AddDealAdditionalCommunicationUser?dealId=" + dealId + "&&userId=" + userId);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public DeleteDealAdditionalCommunicationUser(dealId: any, userId: any): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/DeleteDealAdditionalCommunicationUser?dealId=" + dealId + "&&userId=" + userId);
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, { headers: headers })
            .pipe(catchError(err => {
                return utility.handleErrorNew(err);
            }));
    }

    public GetDealsByBrokerId(BrokerId, StatusId): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/GetDealsByBrokerId?BrokerId=" + BrokerId + "&&StatusId=" + StatusId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetDealsByBrokerId', [])));
    }

    public GetAdminDeals(): Observable<any> {
        this.baseUrl = environment.apiBase.concat("Deal/GetAdminSystemDeals" );
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAdminDeals', [])));
    }

    public SearchDeals(parms) {
        this.baseUrl = environment.apiBase.concat("Deal/SearchDeals");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, parms, { headers: headers })
            .pipe(catchError(utility.handleError<any[]>('SearchDeals', [])));
    }

}

